<img *ngIf="track" [src]="track | trackArtworkUrlByEntity : format | withAuth : placeholderUrl" [title]="label || 'artwork'" />
<img *ngIf="trackId" [src]="trackId | trackArtworkUrlById : format | async | withAuth : placeholderUrl" [title]="label || 'artwork'" />
